import React from 'react';

import { View } from 'react-native';
import Colors from "../../../../constants/Colors";

const PaginationRender = ({ index, selectedIndex, userSelectedIndex }) => {

    const selectedSize = { width: 32, height: 32 };
    const unselectedSize = { width: 16, height: 16 };

    const backgroundColor = userSelectedIndex !== -1 ? Colors.tabBarNavigationBackground : 'white';

    return (
        <View
            style={[ selectedIndex === index ? selectedSize : unselectedSize, { borderRadius: 45, backgroundColor: backgroundColor, margin: 6 }]}
        />
    )

}

export default PaginationRender;
